// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2Ijjg","icon":"_2zojN","content":"_24PQl"};